import { writable } from "svelte/store";

let delay = 4;
const toasts = writable([]);

const toastStore = {
  subscribe: toasts.subscribe,
  set: toasts.set,
  clear: () => {
    toasts.set([]);
  },
  push: (label) => {
    toasts.update((items) => {
      return items.concat({
        id : new Date().valueOf(),
        label: label,
        delay: delay
      });
    });
  },
  clean: () => {
    toasts.update((items) => {
      let t = [];
      items.forEach((to) => {
        if (to.delay > 0) {
          t.push(to);
        }
      });
      return t;
    });
  },
};

export function setDelay(d){
    delay = d;
}

export default toastStore;
